import React from 'react';
import { format } from 'date-fns';
import { Flex, Text, Button } from '@leverege/ui-elements';
import { Toolbar } from '@leverege/ui-plugin';
import { Config } from '@leverege/plugin';
import { GlobalState } from '@leverege/ui-redux';
import { DataSources } from '@leverege/ui-attributes';
import S from './PairingDetailRenderer.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const EMPTY = {};
const client = 'DataCardDetail';
export default class PairingDetailRenderer {
  getValueComponent(object, cxt) {
    const {
      type
    } = object;
    const {
      clientProps
    } = cxt;
    const {
      relationship: {
        path
      },
      actions
    } = clientProps;
    const locatorAliasKey = Config.get('LocatorNetwork', 'aliasKey', 'serialNumber');
    const context = {
      client,
      ...cxt,
      clientProps: {
        ...clientProps,
        actions: actions.parent()
      }
    };
    const matchContext = {
      use: 'actionBar',
      path,
      objectType: type,
      client
    };
    const item = object?.data;
    const paired = item?.data?.locator;
    const deviceId = paired?.data?.[locatorAliasKey] || paired?.id;
    const onClick = ({
      data
    }) => {
      const objRef = {
        id: paired?.id,
        type: 'locator',
        ref: actions.getInterfaceUrl().replace(/vehicle(s)?\/(.+)/, (...matches) => {
          const [, plural] = matches;
          return `locator${plural || ''}`;
        }),
        data: paired
      };
      const lActions = DataSources.getActions(objRef);
      GlobalState.dispatch(lActions.parent().goTo(paired?.id));
    };
    return /*#__PURE__*/_jsxs(Flex, {
      className: S.row,
      align: "center",
      justify: "space-between",
      variant: "pairDetail",
      children: [paired ? /*#__PURE__*/_jsxs(Flex, {
        variant: "colM",
        children: [/*#__PURE__*/_jsxs(Flex, {
          variant: "rowM",
          align: "center",
          children: [/*#__PURE__*/_jsx(Text, {
            variant: "subtitle",
            children: "Locator"
          }), /*#__PURE__*/_jsx(Button, {
            variant: "linkTable",
            onClick: onClick,
            eventData: paired.id,
            children: deviceId
          })]
        }), /*#__PURE__*/_jsxs(Text, {
          children: ["Paired: ", item?.data?.locator?.time ? format(item.data.locator.time, 'P p') : 'Unknown']
        })]
      }) : /*#__PURE__*/_jsx("div", {
        children: "No locator is paired to this vehicle."
      }), /*#__PURE__*/_jsx(Toolbar, {
        variant: "detailActionBar",
        prefer: "text",
        context: context,
        matchContext: matchContext
      })]
    });
  }
  getComponents(object, cxt = EMPTY) {
    return [{
      style: {},
      component: this.getValueComponent(object, cxt)
    }];
  }
}